import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';


// Cambia este valor cada vez que subas a pre para forzar la actualización del caché

const version = process.env.REACT_APP_VERSION;

i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        backend: {
            loadPath: `/locales/{{lng}}/translation.json?version=${version}`,
        },
        fallbackLng: 'es',
        debug: true,
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
        initImmediate: false,
    });

export default i18n;


